"use strict";

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.max-safe-integer");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getGeorgiaRulesList;

var _lodash = _interopRequireDefault(require("lodash"));

var _Asset = _interopRequireDefault(require("../Asset"));

var _IDCounter = _interopRequireDefault(require("../../utils/IDCounter"));

var _Rule = require("../Rule");

var _subTypes = require("../../assets/subTypes");

var _tertiaryTypes = require("../../assets/tertiaryTypes");

var _types = require("../../assets/types");

var _commonRules = require("./commonRules");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var stateCode = 'GA';

function getGeorgiaRulesList(idCounter) {
  return [(0, _commonRules.taxExemptRetirementAccounts)(idCounter, stateCode), {
    id: idCounter.increment(),
    description: 'Motor Vehicles',
    type: stateCode,
    statuteName: 'Ga. Code Ann. § 44-13-100 (a)(3)',
    limitAggregateSingle: 5000,
    limitAggregateJoint: 10000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var type = _lodash["default"].get(asset, 'assetJSON.type');

      return this.canTakeMoreExemptions() && type === _types.VEHICLE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Household Goods, Furnishings, Books, Antiques, Art, Collectibles, Wearing' + ' Apparel, Animals, Hobby Equipment, Crops',
    type: stateCode,
    statuteName: 'Ga. Code Ann. § 44-13-100 (a)(4)',
    limitAggregateSingle: 5000,
    limitAggregateJoint: 10000,
    // NOTE: The norm is that lawyers list all household goods together, not itemized even though that's the statute.
    // limitPerItem: 300,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubtypes = [_subTypes.HOUSEHOLD, _subTypes.BOOK, _subTypes.ANTIQUE, _subTypes.ARTWORK, _subTypes.COLLECTIBLES, _subTypes.CLOTHES, _subTypes.SPORTS_OR_HOBBY_EQUIPMENT, _subTypes.SPORTS_OR_HOBBY_EQUIPMENT, _subTypes.PERSONAL_ANIMALS, _subTypes.CROPS, _subTypes.ELECTRONICS];
      return this.canTakeMoreExemptions() && validSubtypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Jewelry',
    type: stateCode,
    statuteName: 'Ga. Code Ann. § 44-13-100 (a)(5)',
    limitAggregateSingle: 500,
    limitAggregateJoint: 1000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubtypes = [_subTypes.JEWELRY, _subTypes.WATCH, _subTypes.WEDDING_RINGS];
      return this.canTakeMoreExemptions() && subType === validSubtypes;
    }
  }, {
    id: idCounter.increment(),
    description: 'Produce, rent or profit from exempt property',
    type: stateCode,
    statuteName: 'Ga. Code Ann. § 44-13-18',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.PROFIT_OR_RENT_FROM_PROPERTY;
    }
  }, {
    id: idCounter.increment(),
    description: 'Health aids',
    type: stateCode,
    statuteName: 'Ga. Code Ann. § 44-13-100 (a)(10)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.HEALTHAID;
    }
  }, {
    id: idCounter.increment(),
    description: 'Pension for Employees of nonprofit corporations',
    type: stateCode,
    statuteName: 'Ga. Code Ann. § 44-13-100 (a)(2.1)(B)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.NONPROFIT_WORKER_RETIREMENT;
    }
  }, {
    id: idCounter.increment(),
    description: 'State, county, city employees pensions',
    type: stateCode,
    statuteName: 'Ga. Code Ann. § 47-2-332',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubtypes = [_tertiaryTypes.STATE_EMPLOYEES_PENSION, _tertiaryTypes.DISTRICT_EMPLOYEES_PENSION, _tertiaryTypes.COUNTY_EMPLOYEES_PENSION, _tertiaryTypes.MUNICIPAL_EMPLOYEES_PENSION];
      return this.canTakeMoreExemptions() && validSubtypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Legislators\' pensions',
    type: stateCode,
    statuteName: 'Ga. Code Ann. § 47-6-100',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.LEGISLATORS_PENSIONS;
    }
  }, {
    id: idCounter.increment(),
    description: 'IRA, ERISA',
    type: stateCode,
    statuteName: 'Ga. Code Ann. § 18-4-22',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && (subType === _subTypes.IRA || tertiaryType === _tertiaryTypes.ERISA_REITREMENT_PLAN);
    }
  }, {
    id: idCounter.increment(),
    description: 'Reasonably necessary pensions',
    type: stateCode,
    statuteName: 'Ga. Code Ann. § 44-13-100 (a)(2.1)(C); Ga. Code Ann. § 44-13-100 (a)(2)(E)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.PENSION_PLAN;
    }
  }, {
    id: idCounter.increment(),
    description: 'Annuity and endowment contract benefits',
    type: stateCode,
    statuteName: 'Ga. Code Ann. § 33-28-7',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && (subType === _subTypes.ANNUITY || subType === _subTypes.ENDOWMENT_CONTRACT_BENEFITS);
    }
  }, {
    id: idCounter.increment(),
    description: 'Alimony Child Support',
    type: stateCode,
    requiresReview: true,
    statuteName: 'Ga. Code Ann. § 44-13-100 (a)(2)(D)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && (subType === _subTypes.CHILD_SUPPORT || subType === _subTypes.ALIMONY);
    }
  }, {
    id: idCounter.increment(),
    description: 'Lost Future Earnings',
    type: stateCode,
    statuteName: 'Ga. Code Ann. § 44-13-100 (a)(11)(E)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.LOSS_OF_FUTURE_EARNINGS_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Social Security',
    type: stateCode,
    statuteName: 'Ga. Code Ann. § 44-13-100 (a)(2)(A)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiarytype = _lodash["default"].get(asset, 'assetJSON.tertiarytype');

      return this.canTakeMoreExemptions() && tertiarytype === _tertiaryTypes.SOCIAL_SECURITY;
    }
  }, {
    id: idCounter.increment(),
    description: 'Unpaid Wages - 75% or 30 times hourly federal, whichever is greater',
    requiresReview: true,
    type: stateCode,
    statuteName: 'Ga. Code Ann. § 18-4-20',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.UNPAID_WAGES;
    }
  }, {
    id: idCounter.increment(),
    description: 'Disability or health benefits',
    type: stateCode,
    statuteName: 'Ga. Code Ann. § 33-29-15; Ga. Code Ann. § 33-30-10',
    limitAggregateSingle: 250,
    limitAggregateJoint: 500,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && (tertiaryType === _tertiaryTypes.DISABILITY_BENEFITS || tertiaryType === _tertiaryTypes.HEALTH_BENEFITS);
    }
  }, {
    id: idCounter.increment(),
    description: 'Crime victims\' compensation',
    type: stateCode,
    statuteName: 'Ga. Code Ann. § 44-13-100 (a)(11)(A)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.CRIME_VICTIM_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Personal Injury Settlement',
    type: stateCode,
    statuteName: 'Ga. Code Ann. § 44-13-100 (a)(11)(D)',
    limitAggregateSingle: 10000,
    limitAggregateJoint: 20000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.PERSONAL_INJURY_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Public assistance (local)',
    type: stateCode,
    statuteName: 'Ga. Code Ann. § 44-13-100 (a)(2)(A)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.LOCAL_PUBLIC_ASSISTANCE_BENEFIT;
    }
  }, {
    id: idCounter.increment(),
    description: 'Wrongful death award',
    type: stateCode,
    statuteName: 'Ga. Code Ann. § 44-13-100 (a)(11)(B)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.WRONGFUL_DEATH_AWARD;
    }
  }, {
    id: idCounter.increment(),
    description: 'Veterans benefits, unemployment benefits',
    type: stateCode,
    statuteName: 'Ga. Code Ann. § 44-13-100 (a)(2)(A)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && (tertiaryType === _tertiaryTypes.VETERANS_BENEFITS || tertiaryType === _tertiaryTypes.UNEMPLOYMENT_BENEFITS);
    }
  }, {
    id: idCounter.increment(),
    description: 'Workers Compensation',
    type: stateCode,
    statuteName: 'Ga. Code Ann. § 34-9-84',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.WORKERS_COMP;
    }
  }, {
    id: idCounter.increment(),
    description: 'Wages of deceased state employee',
    type: stateCode,
    statuteName: 'Ga. Code Ann. § 34-7-4',
    limitAggregateSingle: 2500,
    limitAggregateJoint: 5000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.WAGES_OF_DECEASED_STATE_EMPLOYEE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Fraternal benefit',
    type: stateCode,
    statuteName: 'Ga. Code Ann. § 33-15-62',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.FRATERNAL_BENEFIT;
    }
  }, {
    id: idCounter.increment(),
    description: 'Life Insurance Proceeds',
    type: stateCode,
    statuteName: 'Ga. Code Ann. § 33-25-11',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.LIFE_INSURANCE_PROCEEDS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Whole Insurance Plan',
    type: stateCode,
    statuteName: 'Ga. Code Ann. § 33-25-11, Ga. Code Ann. § 44-13-100 (a)(11)(C)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _tertiaryTypes.WHOLE_INSURANCE_PLAN;
    }
  }, {
    id: idCounter.increment(),
    description: 'Industrial life insurance',
    type: stateCode,
    statuteName: 'Ga. Code Ann. § 33-26-5',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.INDUSTRIAL_LIFE_INSURANCE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Unmatured life insurance',
    requiresReview: true,
    type: stateCode,
    statuteName: 'Ga. Code Ann. § 44-13-100 (a)(8)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.UNMATURED_TERM_INSURANCE_POLICY;
    }
  }, {
    id: idCounter.increment(),
    description: 'Life Insurance (group)',
    type: stateCode,
    statuteName: 'Ga. Code Ann. § 33-30-10',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.GROUP_INSURANCE_PLAN;
    }
  }, {
    id: idCounter.increment(),
    description: 'Tools of Trade, Professional Books',
    type: stateCode,
    statuteName: 'Ga. Code Ann. § 44-13-100 (a)(7)',
    limitAggregateSingle: 1500,
    limitAggregateJoint: 3000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && (subType === _subTypes.TOOLS_OF_TRADE || subType === _tertiaryTypes.PROFESSIONAL_LIBRARY);
    }
  }, {
    id: _Rule.WILDCARD_ID,
    type: stateCode,
    requiresReview: true,
    description: 'Wildcard - $1200 of any property plus unused homestead to $10000',
    statuteName: 'Ga. Code Ann. § 44-13-100 (a)(6)',
    limitAggregateSingle: 11200,
    limitAggregateJoint: 22400,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply() {
      return this.canTakeMoreExemptions();
    }
  }];
}